const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export const backend_url = process.env.REACT_APP_BACKEND_URL || (isLocalhost
  ? 'http://localhost:3001/api'
  : `${window.location.origin}/api`);
